export const NEXT_STEP = 'APP/STEPS/NEXT_STEP';
export const BACK_STEP = 'APP/STEPS/BACK_STEP';
export const COMPLETE_STEPS = 'APP/STEPS/COMPLETE_STEPS';
export const ANIMATION = 'APP/STEPS/ANIMATION';
